import { useEffect, useState, type RefObject } from 'react'

export function useNearViewport(ref: RefObject<Element | null>, rootMargin = '100% 0px'): boolean {
  const [near, setNear] = useState(() => typeof IntersectionObserver === 'undefined')

  useEffect(() => {
    if (typeof IntersectionObserver === 'undefined') {
      setNear(true)
      return
    }
    const target = ref.current
    if (target === null) return
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0]
        if (entry !== undefined) setNear(entry.isIntersecting)
      },
      { rootMargin }
    )
    observer.observe(target)
    return () => observer.disconnect()
  }, [ref, rootMargin])

  return near
}
